import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import React, { useRef } from 'react';
import PropTypes from '../../../node_modules/prop-types/index.js';
import Icon from '../Icon/Icon.js';
import TextLink from '../TextLink/TextLink.js';
import { BREAKPOINTS } from '../../spacing/index.js';
import { rem } from '../../utils/functions.js';
import { LinkList, LinkSection, LinkSectionButton, IconWrapper, LinkSectionHeader } from './styledComponents.js';
import useTheme from '../../hooks/useTheme.js';
import useMedia from '../../hooks/useMedia.js';
import useToggle from '../../hooks/useToggle.js';

var LinkDropdown = function LinkDropdown(_ref) {
  var id = _ref.id,
    title = _ref.title,
    links = _ref.links;
  var theme = useTheme();
  var toggleRef = useRef();
  var isCollapsible = useMedia(["(max-width: ".concat(BREAKPOINTS.MAX_768, "px)")], [true], false);
  var _useToggle = useToggle(),
    _useToggle2 = _slicedToArray(_useToggle, 3),
    expanded = _useToggle2[0],
    toggleExpanded = _useToggle2[1],
    setExpanded = _useToggle2[2];
  function handleKeyDown(event) {
    if (event.key === 'Escape') {
      setExpanded(false);
      toggleRef.current.focus();
    }
  }
  var linkList = /*#__PURE__*/React.createElement(LinkList, {
    theme: theme,
    id: "".concat(id, "-list"),
    onKeyDown: handleKeyDown
  }, links.map(function (link) {
    return /*#__PURE__*/React.createElement("li", {
      key: link.id
    }, /*#__PURE__*/React.createElement(TextLink, {
      id: "".concat(id, "-").concat(link.id),
      to: link.href,
      isExternal: link.isExternal
    }, link.title));
  }));
  if (isCollapsible) {
    return /*#__PURE__*/React.createElement(LinkSection, null, /*#__PURE__*/React.createElement(LinkSectionButton, {
      onClick: toggleExpanded,
      "aria-expanded": expanded,
      "aria-haspopup": "true",
      "aria-controls": "".concat(id, "-list"),
      ref: toggleRef,
      role: "button",
      "data-testid": "".concat(id, "-toggle")
    }, /*#__PURE__*/React.createElement(IconWrapper, {
      "aria-hidden": "true"
    }, /*#__PURE__*/React.createElement(Icon, {
      manulifeName: expanded ? 'collapse' : 'expand',
      alt: expanded ? 'collapse' : 'expand',
      fill: theme.colorPalette.accentColor.shade_default,
      width: rem(8),
      height: rem(8)
    })), title), expanded && linkList);
  }
  return /*#__PURE__*/React.createElement(LinkSection, null, /*#__PURE__*/React.createElement(LinkSectionHeader, {
    theme: theme
  }, title), linkList);
};
process.env.NODE_ENV !== "production" ? LinkDropdown.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  links: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    isExternal: PropTypes.bool,
    href: PropTypes.string.isRequired
  }))
} : void 0;
LinkDropdown.defaultProps = {
  links: []
};
process.env.NODE_ENV !== "production" ? LinkDropdown.displayName = 'LinkDropdown' : void 0;
var LinkDropdown$1 = LinkDropdown;

export { LinkDropdown$1 as default };
